import { useCallback, useEffect, useState } from 'react';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { getMaintenanceIssues } from 'services/report';
import { MaintenanceIssues } from 'types/report';

export const useCompletedMaintenanceInjection = () => {
  const [issues, setIssues] = useState<MaintenanceIssues[]>([]);

  const handleGetData = useCallback(async () => {
    const resp = await getMaintenanceIssues({ status: 'RESOLVED', page: 1, size: 99999 });
    setIssues(resp.issues);
  }, []);

  const { asyncCallback, isLoading: loading } = useAsyncCallback(handleGetData, []);

  useEffect(() => {
    asyncCallback();
  }, [asyncCallback]);

  return {
    issues,
    loading
  };
};
